<template>
  <!-- native browser viewer for pdfs   -->
  <div v-if="getFileExtension(url) == 'pdf'">
    <object
      :key="filename + '_pdf'"
      :data="
        url +
        '?#view=fitV' +
        (hideToolbar ? '&toolbar=0&navpanes=0&scrollbar=0' : '')
      "
      :height="height + 'px'"
      width="100%"
      type="application/pdf"
      class="fullScreenViewer"
    >
      <param name="view" value="fitV" />
      <!-- Mobile handle for non native pdf support -->
      <embed
        :style="'height:' + height + 'px; width:100%;'"
        :key="filename + '_embed'"
        :src="'http://docs.google.com/gview?url=' + url + '&embedded=true'"
      />
    </object>
  </div>

  <div v-else>
    <!-- Non images files -->
    <iframe
      :key="filename + '_iframe'"
      v-if="!fileIsImage(url) && getFileExtension(url) != 'pdf'"
      :src="'https://docs.google.com/viewer?url=' + url + '&embedded=true'"
      :style="'height:' + height + 'px; width:100%;'"
      frameborder="0"
    ></iframe>
    <!-- Images -->

    <viewer
      v-else
      :options="imgViewerOptions"
      :images="[url]"
      ref="viewer"
      @inited="inited"
      :style="'height:' + height + 'px;'"
    >
      <template slot-scope="scope">
        <img
          v-show="false"
          v-for="src in scope.images"
          :src="src"
          :key="src + '_img'"
        />
      </template>
    </viewer>
  </div>
</template>

<script>
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer/src/component.vue";

export default {
  components: {
    Viewer,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    filename: {
      type: String,
      required: false,
      default: ""
    },
    height: {
      type: String,
      required: false,
      default: "900",
    },
    hideToolbar: {
      type: Boolean,
      required: false,
      default: false,
    } ,
    fullScreenViewer: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    fileIsImage(filename) {
      var extension = this.getFileExtension(filename);
 
      return (
        extension == "jpeg" ||
        extension == "jpg" ||
        extension == "png" ||
        extension == "gif" ||
        extension == "bmp"
      );
    },
    getFileExtension(filename) {
      console.log("ext",filename.substring(filename.lastIndexOf(".") + 1, filename.length))
      return (
        filename.substring(filename.lastIndexOf(".") + 1, filename.length) ||
        filename
      );

    },
    inited(viewer) {
      this.$viewer = viewer;
    },
    show() {
      this.$viewer.show();
    },
  },
  data() {
    return {
      imgViewerOptions: { inline: true, navbar: false },
    };
  },
};
</script>
<style>

.fullScreenViewer {
  min-height: calc(100vh - 42px);
  height: calc(100vh - 42px);
}


.fitContainer {
  max-width: 100%;
  max-height: 100%;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}

.viewer-backdrop {
  background-color: white;
}

.viewer-toolbar > ul > li {
  background-color: var(--v-theme_primary-base);
}

.viewer-title {
  color: #2c2c2c;
}
</style>
